import React, { useEffect, useState } from 'react'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import { FaShare, FaCommentDots, FaChevronLeft, FaChevronRight, FaMapMarkerAlt, FaUtensils, FaWifi, FaMusic,FaCopy, FaDirections  } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { CiHeart } from "react-icons/ci";
import { FcLike } from "react-icons/fc";
import { ClockLoader } from "react-spinners"
import { gapi } from 'gapi-script'
import axios from 'axios';
import Modal from 'react-modal';
import { Link, useSearchParams } from 'react-router-dom';
import Comments from './Comments';
import Nav from './common/Nav';
import ImagePickerComponent from './ImagePicker';
import ImageContainer from './ImageContainer'
import { host, clienturl, GOOGLE_CLIENT_ID } from './script/variables';
import uploadViaPresign from './script/uploadViaPresignV2';
import SEOMeta from './common/SEOMeta';
import FeedImageEditor from './FeedImageEditor';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { useRef } from 'react';
import './style/theme.css';

const clientID = GOOGLE_CLIENT_ID

/* ─── Inline styles ─────────────────────────────────────────── */
const styles = `
  /* theme.css is imported as a real ES module above — its :root
     tokens (var(--clay), var(--bg), etc.) are already loaded into
     the document, so this inline <style> block can reference them
     directly without its own @import (a CSS @import inside a
     runtime-injected <style> tag would resolve against the page
     URL, not this file's location, and silently fail to load). */

  /* Customer-facing restaurant page — Clay accent applies here
     per brand guidelines (FoodFinder / diner-facing "order" and
     "share moment" interactions), matching CafePage.css. */
  :root {
    --cream:    var(--bg);
    --rust:     var(--clay);
    --rust-lt:  var(--accent-light);
    --amber:    var(--warning);
    --amber-lt: var(--warning-light);
    --charcoal: var(--text);
    --smoke:    var(--surface2);
    --muted:    var(--text-muted);
    --white:    var(--surface);
    --green:    var(--success);
    --green-lt: var(--success-light);
    --purple:   var(--accent2);
    --purple-lt:rgba(132,169,192,0.12);
    --shadow:   var(--shadow-md);
    /* --radius, --radius-sm, and --shadow-sm already match
       theme.css names exactly and resolve automatically — not
       redeclared here to avoid a circular var() reference. */
  }

  * { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    background: var(--cream);
    font-family: var(--font-body);
    color: var(--charcoal);
  }

  /* ── Page wrapper / large-screen layout ── */
  .cp-page {
    max-width: 1200px;
    margin: 0 auto;
  }

  /* ── Hero ── */
  .cp-hero {
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    overflow: hidden;
    background: var(--charcoal);
    max-height: 520px;
  }
  @media (max-width: 768px) {
    .cp-hero { aspect-ratio: 4/3; max-height: 320px; }
  }
  .cp-hero .carousel__slider { height: 100%; }
  .cp-hero img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .cp-hero-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(to top, rgba(15,37,52,.75) 0%, rgba(15,37,52,.1) 50%, transparent 100%);
    pointer-events: none;
  }
  .cp-hero-meta {
    position: absolute;
    bottom: 0; left: 0; right: 0;
    padding: 20px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .cp-hero-cat {
    display: inline-flex;
    align-items: center;
    background: var(--amber);
    color: var(--text-inverse);
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: .12em;
    text-transform: uppercase;
    padding: 3px 10px;
    border-radius: 50px;
    width: fit-content;
  }
  .cp-hero-name {
    font-family: var(--font-heading);
    font-size: clamp(1.8rem, 5vw, 2.8rem);
    font-weight: 700;
    color: var(--white);
    letter-spacing: -0.01em;
    line-height: 1.1;
  }
  .cp-hero-tagline {
    font-size: 0.82rem;
    color: rgba(255,255,255,.72);
    font-weight: 400;
    max-width: 480px;
  }

  /* carousel nav */
  .carousel__back-button,
  .carousel__next-button {
    position: absolute;
    top: 50%; transform: translateY(-50%);
    background: rgba(255,255,255,.18);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,.2);
    border-radius: 50%;
    width: 38px; height: 38px;
    display: flex; align-items: center; justify-content: center;
    color: var(--text-inverse);
    cursor: pointer;
    z-index: 10;
    transition: background .2s;
  }
  .carousel__back-button { left: 14px; }
  .carousel__next-button { right: 14px; }
  .carousel__back-button:hover,
  .carousel__next-button:hover { background: rgba(255,255,255,.35); }

  /* ── Two-column layout for desktop ── */
  .cp-main-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0;
  }
  @media (min-width: 900px) {
    .cp-main-grid {
      grid-template-columns: minmax(0, 1fr) 340px;
      gap: 0 32px;
      padding: 28px 24px;
      align-items: start;
    }
  }
  @media (min-width: 1100px) {
    .cp-main-grid {
      grid-template-columns: minmax(0, 1fr) 380px;
    }
  }

  .cp-main-left { min-width: 0; }
  .cp-main-right {
    position: sticky;
    top: 72px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  @media (max-width: 899px) {
    .cp-main-right { padding: 0 16px 16px; }
  }

  /* ── Action bar ── */
  .cp-action-bar {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: var(--white);
    padding: 12px 0;
    border-bottom: 1px solid var(--smoke);
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 12px rgba(15,37,52,.06);
  }
  .cp-action-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    padding: 4px 8px;
  }
  .cp-action-icon {
    width: 42px; height: 42px;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    background: var(--smoke);
    font-size: 1.15rem;
    transition: background .2s, transform .15s;
  }
  .cp-action-icon:active { transform: scale(.92); }
  .cp-action-icon.liked { background: var(--error-light); }
  .cp-action-label {
    font-size: 0.63rem;
    font-weight: 600;
    color: var(--muted);
    letter-spacing: .05em;
    text-transform: uppercase;
  }
  .cp-action-count {
    font-size: 0.82rem;
    font-weight: 700;
    color: var(--charcoal);
  }

  /* ── Section ── */
  .cp-section {
    padding: 22px 16px 0;
  }
  @media (min-width: 900px) {
    .cp-section { padding: 22px 0 0; }
  }
  .cp-section-title {
    font-family: var(--font-heading);
    font-size: 1.2rem;
    font-weight: 700;
    color: var(--charcoal);
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .cp-section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--smoke);
  }

  /* ── Pill/tag chips ── */
  .cp-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 4px;
  }
  .cp-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 12px;
    border-radius: 50px;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: .02em;
    transition: transform .15s;
    cursor: default;
    white-space: nowrap;
  }
  .cp-chip:active { transform: scale(.96); }
  .cp-chip.ambience {
    background: var(--amber-lt);
    color: var(--amber);
    border: 1px solid var(--warning);
  }
  .cp-chip.vibe {
    background: var(--purple-lt);
    color: var(--purple);
    border: 1px solid rgba(132,169,192,.35);
  }
  .cp-chip.occasion {
    background: var(--green-lt);
    color: var(--green);
    border: 1px solid var(--success);
  }
  .cp-chip-icon { font-size: 0.9rem; }

  /* atmosphere card (desktop sidebar) */
  .cp-atm-card {
    background: var(--white);
    border-radius: var(--radius);
    padding: 18px;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--smoke);
  }
  .cp-atm-card-title {
    font-family: var(--font-heading);
    font-size: 1rem;
    font-weight: 700;
    color: var(--charcoal);
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .cp-atm-group {
    margin-bottom: 12px;
  }
  .cp-atm-group:last-child { margin-bottom: 0; }
  .cp-atm-label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: var(--muted);
    margin-bottom: 6px;
  }

  /* ── Gallery grid (fixed small thumbnails) ── */
  .cp-gallery-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
  }
  @media (min-width: 600px) {
    .cp-gallery-grid { grid-template-columns: repeat(4, 1fr); }
  }
  @media (min-width: 900px) {
    .cp-gallery-grid { grid-template-columns: repeat(3, 1fr); }
  }
  .cp-gallery-thumb {
    aspect-ratio: 1;
    overflow: hidden;
    border-radius: var(--radius-sm);
    background: var(--smoke);
    cursor: pointer;
  }
  .cp-gallery-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform .3s ease;
  }
  .cp-gallery-thumb:hover img { transform: scale(1.06); }
  .cp-gallery-more {
    display: block;
    text-align: center;
    margin: 12px 0 0;
    color: var(--rust);
    font-weight: 600;
    font-size: 0.85rem;
    text-decoration: none;
    padding: 10px;
  }
  .cp-gallery-empty {
    text-align: center;
    padding: 32px 20px;
    color: var(--muted);
    font-size: 0.88rem;
    cursor: pointer;
    background: var(--smoke);
    border-radius: var(--radius);
  }
  .cp-gallery-empty span { display: block; font-size: 2rem; margin-bottom: 8px; }

  /* ── Info cards (sidebar on desktop, inline on mobile) ── */
  .cp-info-card {
    background: var(--white);
    border-radius: var(--radius);
    padding: 18px;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--smoke);
  }
  .cp-info-card-title {
    font-family: var(--font-heading);
    font-size: 1rem;
    font-weight: 700;
    color: var(--charcoal);
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  /* ── Order button ── */
  .cp-order-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background: var(--rust);
    color: var(--white) !important;
    text-decoration: none !important;
    border-radius: var(--radius);
    padding: 15px 20px;
    font-family: var(--font-body);
    font-size: 0.95rem;
    font-weight: 700;
    box-shadow: 0 4px 18px rgba(198,106,58,.28);
    transition: transform .15s, box-shadow .15s;
    -webkit-tap-highlight-color: transparent;
    letter-spacing: .02em;
  }
  .cp-order-btn:active { transform: scale(.98); box-shadow: 0 2px 8px rgba(198,106,58,.2); }
  .cp-order-btn:hover { box-shadow: 0 6px 24px rgba(198,106,58,.36); }

  /* ── Map ── */
  .cp-map-wrap {
    border-radius: var(--radius);
    overflow: hidden;
    box-shadow: var(--shadow);
  }
  .cp-map-wrap iframe {
    width: 100%;
    height: 200px;
    border: none;
    display: block;
  }
  @media (min-width: 900px) {
    .cp-map-wrap iframe { height: 220px; }
  }

  /* ── FAB ── */
  .cp-fab {
    position: fixed;
    bottom: 24px; right: 20px;
    background: var(--rust);
    color: var(--white);
    border: none;
    border-radius: 50px;
    padding: 13px 20px;
    font-family: var(--font-body);
    font-size: 0.85rem;
    font-weight: 700;
    display: flex; align-items: center; gap: 8px;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(198,106,58,.35);
    z-index: 200;
    transition: transform .15s, box-shadow .15s;
    -webkit-tap-highlight-color: transparent;
  }
  .cp-fab:active { transform: scale(.96); }

  /* ── Share sheet ── */
  .cp-sheet-backdrop {
    position: fixed; inset: 0;
    background: rgba(0,0,0,.45);
    z-index: 300;
    animation: fadeIn .2s;
  }
  .cp-sheet {
    position: fixed;
    bottom: 0; left: 0; right: 0;
    background: var(--white);
    border-radius: 24px 24px 0 0;
    padding: 20px 20px 44px;
    z-index: 301;
    animation: slideUp .25s cubic-bezier(.22,.61,.36,1);
  }
  .cp-sheet-handle {
    width: 40px; height: 4px;
    border-radius: 99px;
    background: var(--border-strong);
    margin: 0 auto 20px;
  }
  .cp-sheet-title {
    font-family: var(--font-heading);
    font-size: 1.15rem;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .cp-share-options { display: flex; gap: 16px; }
  .cp-share-opt {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
  }
  .cp-share-opt-icon {
    width: 56px; height: 56px;
    border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    font-size: 1.6rem;
    transition: transform .15s;
  }
  .cp-share-opt-icon:active { transform: scale(.92); }
  .cp-share-opt-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--muted);
  }
  .cp-share-opt.whatsapp .cp-share-opt-icon { background: var(--success-light); }
  .cp-share-opt.facebook .cp-share-opt-icon { background: var(--accent-light); }
  .cp-share-opt.copy     .cp-share-opt-icon { background: var(--smoke); }

  /* ── Modal ── */
  .ReactModal__Overlay {
    background: rgba(0,0,0,.6) !important;
    z-index: 400 !important;
    display: flex; align-items: flex-end;
  }
  .ReactModal__Content {
    position: relative !important;
    inset: unset !important;
    width: 100% !important;
    max-height: 92vh !important;
    border-radius: 24px 24px 0 0 !important;
    padding: 24px 20px 40px !important;
    overflow-y: auto !important;
    transform: none !important;
    border: none !important;
  }
  .cp-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 20px;
  }
  .cp-modal-title {
    font-family: var(--font-heading);
    font-size: 1.2rem;
    font-weight: 700;
  }
  .cp-modal-close {
    width: 36px; height: 36px;
    border-radius: 50%;
    border: none;
    background: var(--smoke);
    font-size: 1rem;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: var(--charcoal);
  }
  .cp-uploading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 40px 0;
    color: var(--muted);
    font-size: 0.9rem;
  }

  /* ── Description text ── */
  .cp-description {
    font-size: 0.9rem;
    line-height: 1.7;
    color: var(--charcoal);
  }

  /* ── Empty chip state ── */
  .cp-chips-empty {
    font-size: 0.82rem;
    color: var(--muted);
    font-style: italic;
  }

  /* ── Bottom padding for FAB ── */
  .cp-page-end { height: 90px; }

  @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
  @keyframes slideUp { from { transform: translateY(100%) } to { transform: translateY(0) } }


  .cp-ratings-card {
  border: 1px solid var(--accent-light);
  border-radius: 14px;
  overflow: hidden;
  background: var(--white);
}

.cp-ratings-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border-bottom: 1px solid rgba(15,37,52,0.07);
  flex-wrap: wrap;
}

.cp-ratings-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 56px;
}

.cp-score-num {
  font-size: 34px;
  font-weight: 700;
  color: var(--rust);
  line-height: 1;
}

.cp-score-label {
  font-size: 11px;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: .06em;
}

.cp-ratings-bars {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.cp-bar-row {
  display: flex;
  align-items: center;
  gap: 5px;
}

.cp-bar-n {
  font-size: 11px;
  color: var(--muted);
  width: 8px;
}

.cp-bar-track {
  flex: 1;
  height: 5px;
  background: var(--rust-lt);
  border-radius: 3px;
  overflow: hidden;
}

.cp-bar-fill {
  height: 100%;
  background: var(--rust);
  border-radius: 3px;
  transition: width .4s ease;
}

.cp-ratings-count {
  font-size: 11px;
  color: var(--muted);
  white-space: nowrap;
  align-self: flex-end;
}

.cp-ratings-rows {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.cp-rating-row {
  display: flex;
  align-items: center;
  gap: 9px;
}

.cp-rating-icon { font-size: 15px; width: 20px; text-align: center; }

.cp-rating-label {
  flex: 1;
  font-size: 13px;
  color: var(--charcoal);
}

.cp-rating-val {
  font-size: 13px;
  font-weight: 700;
  color: var(--rust);
  min-width: 28px;
  text-align: right;
}

.cp-ratings-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 16px;
  color: var(--muted);
  font-size: 13px;
  text-align: center;
}


/* ── Direction card ─────────────────────────────────────── */
.cp-direction-wrap {
  padding: 0 16px 16px;
}

.cp-direction-card {
  border: 1px solid var(--accent-light);
  border-radius: 14px;
  overflow: hidden;
  background: var(--white);
}

/* Address strip */


.cp-addr-eyebrow {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--text-light);
}




.cp-addr-copy:active {
  background: var(--accent-light);
}

/* Map */
.cp-direction-card .cp-map-wrap {
  border-radius: 0;
  border-left: none;
  border-right: none;
}

.cp-direction-card .cp-map-wrap iframe {
  width: 100%;
  height: 180px;
  border: none;
  display: block;
}

/* Get directions button */
.cp-dir-btn-wrap {
  padding: 10px 14px;
}

.cp-dir-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  padding: 10px 14px;
  background: var(--rust);
  color: var(--text-inverse);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: .01em;
  transition: background .18s;
}

.cp-dir-btn:active {
  background: #B03A0C;
}

.cp-addr-strip {
  display: flex;
  align-items: flex-start;   /* was flex-start — keep it, but also fix the text */
  justify-content: space-between;
  gap: 10px;
  padding: 11px 14px;
  border-bottom: 1px solid rgba(15,37,52,0.07);
}

.cp-addr-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.cp-addr-text {
  font-size: 13px;
  color: var(--charcoal);
  line-height: 1.5;
  word-break: break-word;    /* breaks long unspaced strings */
  white-space: normal;       /* lets it wrap naturally */
}

.cp-addr-copy {
  flex-shrink: 0;
  align-self: flex-start;    /* pins copy button to top-right, text wraps below */
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1px solid var(--accent-light);
  border-radius: 8px;
  background: var(--rust-lt);
  color: var(--rust);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background .15s;
  white-space: nowrap;
}
`;

const modalStyles = {
  overlay: {
    background: 'rgba(0,0,0,.6)',
    zIndex: 400,
    display: 'flex',
    alignItems: 'flex-end',
  },
  content: {
    position: 'relative',
    inset: 'unset',
    width: '100%',
    maxHeight: '92vh',
    borderRadius: '24px 24px 0 0',
    padding: '24px 20px 40px',
    overflowY: 'auto',
    transform: 'none',
    border: 'none',
  },
};

/* ─── Ambience/Vibe/Occasion icon maps ─── */
const ambienceIcons = { cozy: '🕯️', rooftop: '🌇', outdoor: '🌿', indoor: '🏠', rustic: '🪵', modern: '✨', vintage: '📻', industrial: '🏭' };
const vibeIcons = { romantic: '💑', casual: '😊', lively: '🎉', quiet: '🤫', artsy: '🎨', trendy: '💫', chill: '🧘', festive: '🎊' };
const occasionIcons = { birthday: '🎂', anniversary: '💍', 'date night': '🕯️', brunch: '🥂', lunch: '🍽️', dinner: '🌙', family: '👨‍👩‍👧', friends: '👯', business: '💼', solo: '☕' };




const getIcon = (map, label) => map[label?.toLowerCase()] ?? '•';

/* ─── Gallery thumbnail component ─── */
const GalleryGrid = ({ media }) => (
  <div className="cp-gallery-grid">
    {media.slice(0, 6).map((item, i) => (
      <div className="cp-gallery-thumb" key={i}>
        <img src={item.imageurl} alt={item.description || `Gallery ${i + 1}`} loading="lazy" />
      </div>
    ))}
  </div>
);

/* ─── Chip row ─── */
const ChipRow = ({ items, type, iconMap }) => {
  if (!items || items.length === 0) return <span className="cp-chips-empty">Not specified</span>;
  return (
    <div className="cp-chips">
      {items.filter(Boolean).map((item, i) => (
        <span key={i} className={`cp-chip ${type}`}>
          <span className="cp-chip-icon">{getIcon(iconMap, item)}</span>
          {item}
        </span>
      ))}
    </div>
  );
};

/* ─── Component ─────────────────────────────────────────────── */
const CafePage = () => {
  const [islike, setIsLike] = useState(false)
  const [likesCount, setLikesCount] = useState(0)
  const [commentCount, setCommentCount] = useState(0)
  const [views, setViews] = useState(1)
  const [shares, setShare] = useState(0)
  const [isLogin, setIsLogin] = useState(false)
  const [showShare, setShowShare] = useState(false)
  const [comment, setComment] = useState(false)
  const [imgCaption, setImgCaption] = useState('')
  const [imageSrc, setImageSrc] = useState('');
  const [isUploading, setUploading] = useState(false)
  const [pageNo, setpageNumber] = useState(1)
  const [media, setMEdia] = useState([])
  const [imageUrls, setImageUrls] = useState([])
  const [modalIsOpen, setIsOpen] = useState(false);
  const [latitude, setLatitude] = useState()
  const [longitude, setLongitude] = useState()
  const [params] = useSearchParams()
  const [cafeId, setCafeId] = useState('')
  const [isDesktop, setIsDesktop] = useState(false)
  const [address, setAddress] = useState({
    landmark: "",
            street: "",
            city: "",
            state: "",
            pin: "",
            country: ""
  })

  const [cafeData, setCafeData] = useState({
    _id: null, likes: 0, name: "", shares: 0, totalComments: 0, views: 1,
    website: "#", thumbnail: "#", menuImages: [], location: [], images: [],
    contact: 0, catagory: "", menu: [], ambience: [], vibe: [], occasion: [],
    description: "", title: ""
  })

  const [ratings, setRatings] = useState({
    avgStaffBehaviourRating: 0,
    avgFoodQualityRating: 0,
    avgFoodPricingRating: 0,
    avgOverallExperienceRating: 0,
    avgCleaninessRating: 0,
    ratingCount: 0
  })

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= 900)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])


  const StarRow = ({ value = 0, size = 12 }) => {
  const clamped = Math.min(5, Math.max(0, value));
  const full    = Math.floor(clamped);
  const frac    = clamped - full;
  const empty   = 5 - full - (frac > 0 ? 1 : 0);
  const id      = useRef(`hc-${Math.random().toString(36).slice(2, 6)}`).current;

  const Star = ({ type }) => (
    <svg width={size} height={size} viewBox="0 0 10 10" aria-hidden="true">
      {type === 'partial' && (
        <defs>
          <clipPath id={id}>
            <rect x="0" y="0" width={frac * 10} height="10" />
          </clipPath>
        </defs>
      )}
      <polygon
        points="5,1 6.5,4 10,4.5 7.5,7 8,10 5,8.5 2,10 2.5,7 0,4.5 3.5,4"
        fill={type === 'empty' ? 'none' : 'var(--clay)'}
        stroke="var(--clay)"
        strokeWidth="0.8"
        clipPath={type === 'partial' ? `url(#${id})` : undefined}
      />
      {type === 'partial' && (
        <polygon
          points="5,1 6.5,4 10,4.5 7.5,7 8,10 5,8.5 2,10 2.5,7 0,4.5 3.5,4"
          fill="none"
          stroke="var(--clay)"
          strokeWidth="0.8"
        />
      )}
    </svg>
  );

  return (
    <div style={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      {Array.from({ length: full  }).map((_, i) => <Star key={`f${i}`} type="full"    />)}
      {frac > 0                                  && <Star key="p"       type="partial" />}
      {Array.from({ length: empty }).map((_, i) => <Star key={`e${i}`} type="empty"   />)}
    </div>
  );
};

  /* ── API helpers ── */
  const hitShare = async () => {
    const token = localStorage.getItem('token')
    await fetch(`${host}/actions/share?cafeid=${params.get('cafeid')}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `${token}` },
    }).catch(console.error)
    setShare(s => s + 1)
  }

  const checkLogin = async () => {
    const token = localStorage.getItem('token')
    const res = await fetch(`${host}/user/vlogin`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `${token}` },
    }).catch(() => null)
    setIsLogin(res?.ok ?? false)
  }

  const fetchCafeDetails = async () => {
    const id = params.get('cafeid')
    setCafeId(id)
    const token = localStorage.getItem('token')
    const res = await fetch(`${host}/outlet/findOutletById?cafeid=${id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `${token}` },
    }).catch(() => null)
    if (!res?.ok) return
    const data = await res.json()
    if (data.isLike) setIsLike(true)
    setCafeData(data.data)
    setCommentCount(data.data.totalComments)
    setLikesCount(data.data.likes)
    setViews(data.data.views)
    setShare(data.data.shares)
    setLongitude(data.data.location?.coordinates?.[0])
    setLatitude(data.data.location?.coordinates?.[1])
    setAddress({
      landmark: data.data.address?.landmark || "",
      street: data.data.address?.street || "",
      city: data.data.address?.city || "",
      state: data.data.address?.state || "",
      pin: data.data.address?.pin || "",
      country: data.data.address?.country || ""
    })
  }


  const fetchRatings = async () => {


    try{
      const res = await fetch(`${host}/masala/getratings?cafeid=${params.get('cafeid')}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }).catch(() => null)
      if (!res?.ok) return
      const data = await res.json()
      setRatings(data)
    }
      catch(err){
        console.error('Error fetching ratings:', err)
      }

  }
  const fetchMedia = async () => {
    const res = await fetch(
      `${host}/masala/fetchusermedia?cid=${params.get('cafeid')}&pno=${pageNo}&c=6`,
      { method: 'GET', headers: { 'Content-Type': 'application/json' } }
    ).catch(() => null)
    if (!res?.ok) return
    const respmedia = await res.json()
    setMEdia(respmedia)
    setImageUrls(respmedia.map(f => ({ original: f.imageurl, thumbnail: f.imageurl, desc: f.description, time: f.createdAt })))
  }

  const insertMediaInDb = async (imgUrl, caption) => {
    const token = localStorage.getItem('token')
    const res = await fetch(`${host}/actions/media/post`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `${token}` },
      body: JSON.stringify({ imgUrl, imgCaption: caption, cafeId }),
    }).catch(() => null)
    if (res?.ok) {
      setUploading(false)
      setImgCaption('')
      setImageSrc('')
      alert('Photo shared!')
      fetchMedia()
      
    }
  }

  const uploadFile = async () => {
    let contentType = ''
    if (imageSrc.startsWith('data:image/jpeg')) contentType = 'image/jpeg'
    else if (imageSrc.startsWith('data:image/png')) contentType = 'image/png'
    else { alert('Please use JPEG or PNG'); return }

    const base64Data = imageSrc.replace(/^data:image\/\w+;base64,/, '')
    const byteArray = new Uint8Array([...atob(base64Data)].map(c => c.charCodeAt(0)))
    const ext = contentType === 'image/jpeg' ? 'jpg' : 'png'
    const file = new File([byteArray], `moment.${ext}`, { type: contentType })

    try {
      setUploading(true)
      const imgUrl = await uploadViaPresign(file, 'moment')
      setIsOpen(false)
      insertMediaInDb(imgUrl, imgCaption)
    } catch (err) {
      setUploading(false)
      alert('Upload error: ' + err.message)
    }
  }

  const hitLike = async () => {
    if (!isLogin) { alert('Please login first'); return }
    setLikesCount(l => islike ? l - 1 : l + 1)
    setIsLike(l => !l)
    const token = localStorage.getItem('token')
    await axios.get(`${host}/actions/like?like=${islike}&cafeid=${cafeId}`, {
      headers: { Authorization: token }
    }).catch(console.error)
  }

  const handleShareMoment = () => {
    if (!isLogin) { alert('Please login first'); return }
    setIsOpen(true)
  }

  const copyLink = () => {
    hitShare()
    navigator.clipboard.writeText(`${clienturl}moredetails?cafeid=${cafeId}`)
    alert('Link copied!')
  }

  useEffect(() => {
    gapi.load('client:auth2', () => gapi.client.init({ clientId: clientID, scope: "" }))
    fetchCafeDetails()
    checkLogin()
    fetchMedia()
    fetchRatings()
  }, [])

  /* ── Atmosphere section (used in both mobile inline & desktop sidebar) ── */
  const AtmosphereContent = () => (
    <>
      <div className="cp-atm-group">
        <div className="cp-atm-label">🌿 Ambience</div>
        <ChipRow items={cafeData.ambience} type="ambience" iconMap={ambienceIcons} />
      </div>
      <div className="cp-atm-group">
        <div className="cp-atm-label">✨ Vibe</div>
        <ChipRow items={cafeData.vibe} type="vibe" iconMap={vibeIcons} />
      </div>
      <div className="cp-atm-group">
        <div className="cp-atm-label">🎉 Best For</div>
        <ChipRow items={cafeData.occasion} type="occasion" iconMap={occasionIcons} />
      </div>
    </>
  )

  return (
    <>
      {cafeData && (
        <SEOMeta
          title={cafeData.name}
          description={cafeData.title || `Visit ${cafeData.name} on FoodieAdvisor`}
          image={cafeData.thumbnail}
          url={`${clienturl}moredetails?id=${cafeData._id}`}
        />
      )}

      <style>{styles}</style>
      <Nav isLogin={isLogin} setIsLogin={setIsLogin} />

      <div className="cp-page">

        {/* ── Hero Carousel ── */}
        <div className="cp-hero">
          <CarouselProvider naturalSlideWidth={100} naturalSlideHeight={70} totalSlides={cafeData.images.length || 1}>
            <Slider>
              {cafeData.images.length > 0
                ? cafeData.images.map((img, i) => (
                  <Slide key={i} index={i}>
                    <img src={img} alt={`${cafeData.name} ${i + 1}`} />
                  </Slide>
                ))
                : <Slide index={0}><div style={{ width: '100%', height: '100%', background: 'var(--console-bg)' }} /></Slide>
              }
            </Slider>
            <ButtonBack><FaChevronLeft size={13} /></ButtonBack>
            <ButtonNext><FaChevronRight size={13} /></ButtonNext>
            <div className="cp-hero-overlay" />
            <div className="cp-hero-meta">
              {cafeData.catagory && <span className="cp-hero-cat">{cafeData.catagory}</span>}
              <div className="cp-hero-name">{cafeData.name}</div>
              {cafeData.title && <div className="cp-hero-tagline">{cafeData.title}</div>}
            </div>
          </CarouselProvider>
        </div>

        {/* ── Sticky Action Bar ── */}
        <div className="cp-action-bar">
          <div className="cp-action-item" onClick={hitLike}>
            <div className={`cp-action-icon${islike ? ' liked' : ''}`}>
              {islike ? <FcLike /> : <CiHeart />}
            </div>
            <div className="cp-action-count">{likesCount}</div>
            <div className="cp-action-label">Like</div>
          </div>
          {/* <div className="cp-action-item" onClick={() => setComment(c => !c)}>
            <div className="cp-action-icon">
              <FaCommentDots color={comment ? 'var(--clay)' : 'var(--text-muted)'} />
            </div>
            <div className="cp-action-count">{commentCount}</div>
            <div className="cp-action-label">Comment</div>
          </div> */}
          <div className="cp-action-item">
            <div className="cp-action-icon">
              <FaRegEye color="var(--text-muted)" />
            </div>
            <div className="cp-action-count">{views}</div>
            <div className="cp-action-label">Views</div>
          </div>
          <div className="cp-action-item" onClick={() => setShowShare(true)}>
            <div className="cp-action-icon">
              <FaShare color="var(--text-muted)" />
            </div>
            <div className="cp-action-count">{shares}</div>
            <div className="cp-action-label">Share</div>
          </div>
        </div>

        {/* ── Comments ── */}
        {/* {comment && (
          <div className="cp-section"  style={{ marginTop: 8 }}>
            <Comments postid={cafeId} setCommentCount={setCommentCount} commentCount={commentCount} isLogin={isLogin} isBlog={false} />
          </div>
        )} */}

        

        {/* ── Two-column grid ── */}
        <div className="cp-main-grid">

          {/* ── LEFT column ── */}
          <div className="cp-main-left">

            {/* Order button */}
            <div className="cp-section" style={{ paddingTop: 20 }}>
              <Link to={`/orderpage/${cafeId}`} className="cp-order-btn">
                <FaUtensils size={15} />
                Order Now
              </Link>
            </div>

            {/* Description */}
            {cafeData.description ? (
              <div className="cp-section">
                <div className="cp-section-title">About</div>
                <p className="cp-description">{cafeData.description}</p>
              </div>
            ) : null}

            {/* Atmosphere — mobile only (shown inline on small screens) */}
            {!isDesktop && (
              <div className="cp-section">
                <div className="cp-section-title">Atmosphere</div>
                <AtmosphereContent />
              </div>
            )}

            {/* Gallery */}
            <div className="cp-section" style={{ marginTop: 8 }}>
              <div className="cp-section-title">User's Gallery</div>
              {media.length > 0
                ? <>
                  <GalleryGrid media={media} />
                  <a href={`/cafeMedia/ug?cid=${cafeId}`} className="cp-gallery-more">Explore all photos →</a>
                </>
                : <div className="cp-gallery-empty" onClick={handleShareMoment}>
                  <span>📸</span>
                  Be the first to share your moment!
                </div>
              }
            </div>

          
            {/* ── Direction ── */}
<div className="cp-section" style={{ marginTop: 8 }}>
  <div className="cp-section-title">
    <FaMapMarkerAlt size={14} color="var(--clay)" /> Direction
  </div>
</div>

<div className="cp-direction-wrap">
  <div className="cp-direction-card">

    {/* Address strip */}
    {(address.street || address.city || address.state) && (
      <div className="cp-addr-strip">
        <div className="cp-addr-content">
          <span className="cp-addr-eyebrow">Address</span>
          <span className="cp-addr-text">
            {[
              address.street,
              address.landmark,
              address.city,
              address.state,
              address.pin,
              address.country,
            ]
              .filter(Boolean)
              .join(', ')}
          </span>
        </div>
        <button
          className="cp-addr-copy"
          onClick={() => {
            const full = [
              address.street,
              address.landmark,
              address.city,
              address.state,
              address.pin,
              address.country,
            ]
              .filter(Boolean)
              .join(', ');
            navigator.clipboard?.writeText(full);
          }}
          aria-label="Copy address"
        >
          <FaCopy size={12} />
          <span>Copy</span>
        </button>
      </div>
    )}

    {/* Map embed */}
    <div className="cp-map-wrap" style={{ marginBottom: 0 }}>
      <iframe
        src={`https://www.google.com/maps?q=${latitude},${longitude}&z=16&output=embed`}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        title="Cafe Location"
      />
    </div>

    {/* Directions button */}
    <div className="cp-dir-btn-wrap">
      <a
      
        className="cp-dir-btn"
        href={`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaDirections size={15} />
        Open Map
      </a>
    </div>

  </div>
</div>

            {/* Ratings */}
            {/* ── Ratings Section ── */}
<div className="cp-section" style={{ marginTop: 8 }}>
  <div className="cp-section-title">Ratings & Reviews</div>

  {ratings.ratingCount > 0 ? (
    <div className="cp-ratings-card">

      {/* Overall score + bar chart */}
      <div className="cp-ratings-hero">
        <div className="cp-ratings-score">
          <span className="cp-score-num">
            {ratings.avgOverallExperienceRating.toFixed(1)}
          </span>
          <StarRow value={ratings.avgOverallExperienceRating} size={13} />
          <span className="cp-score-label">Overall</span>
        </div>
        <div className="cp-ratings-bars">
          {[5, 4, 3, 2, 1].map(n => {
            /* approximate bar width from available data — replace with real distribution if API provides it */
            const approx = n === Math.round(ratings.avgOverallExperienceRating) ? 40 : Math.max(4, 40 - Math.abs(n - ratings.avgOverallExperienceRating) * 14);
            return (
              <div key={n} className="cp-bar-row">
                <span className="cp-bar-n">{n}</span>
                <svg width="10" height="10" viewBox="0 0 10 10" className="cp-bar-star" aria-hidden="true">
                  <polygon points="5,1 6.5,4 10,4.5 7.5,7 8,10 5,8.5 2,10 2.5,7 0,4.5 3.5,4"
                    fill="var(--clay)" stroke="var(--clay)" strokeWidth="0.8" />
                </svg>
                <div className="cp-bar-track">
                  <div className="cp-bar-fill" style={{ width: `${approx}%` }} />
                </div>
              </div>
            );
          })}
        </div>
        <div className="cp-ratings-count">{ratings.ratingCount} reviews</div>
      </div>

      {/* Per-category rows */}
      <div className="cp-ratings-rows">
        {[
          { label: 'Food quality',    value: ratings.avgFoodQualityRating,       icon: '' },
          { label: 'Staff behaviour', value: ratings.avgStaffBehaviourRating,     icon: '' },
          { label: 'Cleanliness',     value: ratings.avgCleaninessRating,         icon: '' },
          { label: 'Food pricing',    value: ratings.avgFoodPricingRating,        icon: '' },
          { label: 'Overall exp.',    value: ratings.avgOverallExperienceRating,  icon: '' },
        ].map(({ label, value, icon }) => (
          <div key={label} className="cp-rating-row">
            {/* <span className="cp-rating-icon">{icon}</span> */}
            <span className="cp-rating-label">{label}</span>
            <StarRow value={value} size={11} />
            <span className="cp-rating-val">{value.toFixed(1)}</span>
          </div>
        ))}
      </div>

    </div>
  ) : (
    <div className="cp-ratings-empty">
      <span>⭐</span>
      No reviews yet — be the first to rate!
    </div>
  )}
</div>


{/*  Comments section     */}
   {/* <div className="cp-section" style={{ marginTop: 8 }}>
    <div className="cp-section-title">Comments</div>
            <Comments postid={cafeId} setCommentCount={setCommentCount} commentCount={commentCount} isLogin={isLogin} isBlog={false} />
          </div> */}


          {/* {comment && (
          <div className="cp-section"  style={{ marginTop: 8 }}>
            <Comments postid={cafeId} setCommentCount={setCommentCount} commentCount={commentCount} isLogin={isLogin} isBlog={false} />
          </div>
        )} */}

        {cafeId && (
  <div className="cp-section" style={{ marginTop: 8 }}>
    <div className="cp-section-title">Comments</div>
    <Comments postid={cafeId} setCommentCount={setCommentCount} commentCount={commentCount} isLogin={isLogin} isBlog={false} />
  </div>
)}

          </div>

          {/* ── RIGHT column (desktop sidebar) ── */}
          <div className="cp-main-right">

            {/* Atmosphere card — desktop only */}
            {isDesktop && (
              <div className="cp-atm-card">
                <div className="cp-atm-card-title">🌟 Atmosphere</div>
                <AtmosphereContent />
              </div>
            )}

            {/* Order card on desktop */}
            {isDesktop && (
              <Link to={`/orderpage/${cafeId}`} className="cp-order-btn" style={{ margin: 0 }}>
                <FaUtensils size={15} />
                Order Now
              </Link>
            )}

          </div>
        </div>

        <div className="cp-page-end" />
      </div>

      {/* ── Share Moment FAB ── */}
      <button className="cp-fab" onClick={handleShareMoment}>
        😍 Share Moment
      </button>

      {/* ── Share Bottom Sheet ── */}
      {showShare && (
        <>
          <div className="cp-sheet-backdrop" onClick={() => setShowShare(false)} />
          <div className="cp-sheet">
            <div className="cp-sheet-handle" />
            <div className="cp-sheet-title">Share this place</div>
            <div className="cp-share-options">
              <a
                className="cp-share-opt whatsapp"
                href={`whatsapp://send?text=${clienturl}moredetails?cafeid=${cafeId}`}
                target="_blank"
                rel="noreferrer"
                onClick={hitShare}
              >
                <div className="cp-share-opt-icon">🟢</div>
                <div className="cp-share-opt-label">WhatsApp</div>
              </a>
              <a
                className="cp-share-opt facebook"
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${clienturl}moredetails?cafeid=${cafeId}`)}`}
                target="_blank"
                rel="noreferrer"
                onClick={hitShare}
              >
                <div className="cp-share-opt-icon">🔵</div>
                <div className="cp-share-opt-label">Facebook</div>
              </a>
              <div className="cp-share-opt copy" onClick={copyLink}>
                <div className="cp-share-opt-icon">🔗</div>
                <div className="cp-share-opt-label">Copy Link</div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ── Upload Modal ── */}
     <Modal isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)} style={modalStyles} contentLabel="Share Moment">
  {isUploading
    ? <div className="cp-uploading">
        <ClockLoader color="#C46A3A" />
        <span>Uploading your moment…</span>
      </div>
    : <>
        <div className="cp-modal-header">
          <div className="cp-modal-title">Share Your Moment</div>
          <button className="cp-modal-close" onClick={() => setIsOpen(false)}>✕</button>
        </div>
        <FeedImageEditor
          setImgCaption={setImgCaption}
          imgCaption={imgCaption}
          imageSrc={imageSrc}
          setImageSrc={setImageSrc}
          handleSaveMedia={uploadFile}
        />
      </>
  }
</Modal>
    </>
  )
}

export default CafePage